import React from 'react'
import PropTypes from 'prop-types'
import PrintButton from 'components/common/PrintButton/PrintButton'

const BOTPrintCartridge = ({ title }) =>
  <PrintButton title={ title } data-printless data-desktop-only />

BOTPrintCartridge.propTypes = {
  title: PropTypes.string
}

BOTPrintCartridge.type = 'BOTPrintCartridge'

export default BOTPrintCartridge
